import React from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineClock, HiOutlineDocumentDownload } from "react-icons/hi";
import CustomButton from "components/common/Button/CustomButton";
import { formatEstimatedDuration } from "../reportExportUtils";

const ExportQueuedModal = ({ isOpen, onClose, exportRecord }) => {
  const navigate = useNavigate();

  if (!isOpen || !exportRecord) return null;

  const estimated = formatEstimatedDuration(exportRecord.estimated_seconds);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 text-blue-600">
            <HiOutlineClock className="h-6 w-6" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Report is being prepared
            </h3>
            <p className="text-sm text-gray-500">
              {exportRecord.report_label} ({exportRecord.format?.toUpperCase()})
            </p>
          </div>
        </div>

        <p className="mb-2 text-sm text-gray-700">
          This export has{" "}
          <strong>{exportRecord.row_count?.toLocaleString() ?? "many"}</strong>{" "}
          rows, so it is being generated in the background. This usually takes{" "}
          <strong>{estimated}</strong>.
        </p>
        <p className="mb-6 text-sm text-gray-600">
          You can leave this page — your report will appear on the{" "}
          <strong>Export History</strong> page when it is ready to download.
        </p>

        <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
          <CustomButton
            label="Stay on this page"
            variant="secondary"
            clickHandler={onClose}
          />
          <CustomButton
            label="View Export History"
            variant="primary"
            Icon={<HiOutlineDocumentDownload className="h-4 w-4" />}
            clickHandler={() => {
              onClose();
              navigate("/reporting/export-history");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ExportQueuedModal;
